export default "__VITE_ASSET__D00k1Mhl__"